import { Component, Input, OnInit } from '@angular/core';
import { AuditTrailBase } from 'app/shared/models/audit-trail-base.model';
import { PaymentRequestService } from 'app/shared/services/payment-request.service';

@Component({
  selector: 'app-payment-request-audit-trail',
  templateUrl: './payment-request-audit-trail.component.html',
  styleUrls: ['./payment-request-audit-trail.component.scss']
})
export class PaymentRequestAuditTrailComponent implements OnInit {

  @Input() currentObjectId: number;

  auditTrails: AuditTrailBase[];

  constructor(protected paymentRequestService: PaymentRequestService) {
  }

  ngOnInit() {
    this.paymentRequestService.getCollection<AuditTrailBase>('/payment-request/' + this.currentObjectId + '/audit-trail', null, (collection) => this.auditTrails = collection);
  }
}
